<div class="message-container">
   <div *ngIf="ringingChat; let chat" class="sam-form-flex-row">
      <div>
         <samweb-skill-short-info [skills]="chat?.skill?.skills" [skillConfiguration]="chat?.skill?.skillConfiguration">
         </samweb-skill-short-info>
         <div class="main-text">
            {{ chat.peer.name }}
         </div>
         <div class="sub-text">
            {{ chat.peer.email }}
         </div>
      </div>
   </div>
</div>
<button kendoButton (click)="openChat()" class="message-button dial-control-accept">
   <div class="sam-center sam-wiggle">
      <fa-icon [icon]="openMessageIcon" size="2x"></fa-icon>
   </div>
</button>
